import validate from "/usr/src/app/content/n3-packages-094d00fb-1b0b-4896-8550-6f951bf8cd89/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-094d00fb-1b0b-4896-8550-6f951bf8cd89/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}